import React from 'react'

const FormatPrice = ({ price = null, affix = 'kr' }) => {
  return price ? (
    <>
      {new Intl.NumberFormat('is-IS').format(price)} {affix}
    </>
  ) : null
}

export default FormatPrice
